import TranslationProvider from '@/provider/translations.js'
import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'

import { buildFilterQuery } from '@/libs/utils.js'

export const attr_startDate = 'startDate'
export const attr_endDate = 'endDate'
export const attr_amount = 'amount'

export const campaignStates = {
  '': '',
  valid: 'Valida',
  cancelled: 'Cancellata',
  open: 'Aperta',
  closed: 'Chiusa',
  inactive: 'Inattiva'
}

export const getColumns = async () => {
  try {
    let url = `/campaign/columns`
    return  await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getCampaigns = async (page = '1', campaignType = '') => {
  try {
    let url = `/campaign/api/campaign?page=${page}&poll=1&orderBy[field]=updatedAt&orderBy[direction]=DESC`
    if (campaignType) {
      url += `&type=${campaignType}`
    }

    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getCampaign = async (
  campaignId,
  params = {poll: null, stats:null, revisionNumber: null}
) => {
  try {
    let url = `/campaign/api/campaign/${campaignId}`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getCampaignTemplates = async (
  params = { state: 'active', perPage: 100 }
) => {
  try {
    let url = `/campaign/templates`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getCampaignTypes = async (params = {}) => {
  try {
    let url = `/campaign/types`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    const response = await client.get(url)

    return response.map(item => ({
      key: item.key,
      label: item.labels.it
    }))

  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}
